// export const fetchAllArticles = (async())
import * as api from "../api";
import "regenerator-runtime/runtime";
export const fetchArticles = async () => {
  try {
    const { data } = await api.fetchArticles();

    return data;
  } catch (error) {
    console.log(error.response);
    return error.response;
  }
};
export const createArticle = async (formData, dispatch) => {
  try {
    const { data } = await api.createArticle(formData);
  } catch (error) {
    return error.response;
  }
};
export const addComment = async (comment) => {
  try {
    const { data } = await api.addComment(comment);
    return { data };
  } catch (error) {
    return error.response.data;
  }
};

export const searchArticle = async (articleName) => {
  try {
    const { data } = await api.searchArticle(articleName);

    return data;
  } catch (error) {
    return error.response;
  }
};
export const findArticleName = async (name) => {
  try {
    const { data } = await api.findArticleName(name);

    return data;
  } catch (error) {
    return error.response.data;
  }
};
export const fetchArticlesAuthoredBy = async (id) => {
  try {
    const { data } = await api.fetchArticlesAuthoredBy(id);
    return data;
  } catch (error) {}
};

export const fetchPopularPosts = async () => {
  try {
    const { data } = await api.fetchPopularPosts();
    console.log(data, "popular");
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const addRating = async (data, name) => {
  try {
    await api.addRating(data, name);
  } catch (error) {
    return error.response;
  }
};
//not used
export const calculateRating = async (articleId) => {
  try {
    const { data } = await api.calculateRating(articleId);
    console.log(data);
    return data;
  } catch (error) {
    return error.response;
  }
};
//not used
export const checkUserRating = async (name) => {
  try {
    const { data } = api.checkUserRating(name);

    return data;
  } catch (error) {
    return error.response;
  }
};
export const deleteArticle = async (id) => {
  try {
    const { data } = await api.deleteArticle(id);
    return data;
  } catch (error) {
    return error.response;
  }
};
